import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  en: {
    // Homepage - Landing
    welcomeTitle: 'WELCOME TO WRIGHT & TAYLOR',
    welcomeMsg: 'I\'m a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font. Feel free to drag and drop me anywhere you like on your page. I’m a great place for you to tell a story and let your users know a little more about you. This is a great space to write long text about your company and your services.',
    welcomeBtn: 'Explore Our Services',
    // Homepage - Product Section
    productTitle: 'OUR PRODUCT',
    productAttributeTitle1: 'INDOOR & OUTDOOR PAINTING',
    productAttributeDescription1: 'I\'m a paragraph. Click to add your text and edit me. Let your users get to know you.',
    productAttributeTitle2: 'IN-HOME COLOR CONSULTANCY',
    productAttributeDescription2: 'I\'m a paragraph. Click to add your text and edit me. Let your users get to know you.',
    productAttributeTitle3: 'PALETTE PRODUCTION',
    productAttributeDescription3: 'I\'m a paragraph. Click to add your text and edit me. Let your users get to know you.',
    productAttributeTitle4: 'COATS & RESTORATION',
    productAttributeDescription4: 'I\'m a paragraph. Click to add your text and edit me. Let your users get to know you.',
    productBtn: 'All Products',
    // Homepage - About Section
    aboutTitle: 'OUR STORY',
    aboutParagraph: 'Established in 1984 as Syarikat Perusahaan Berjaya before being renamed Berjayapak Sdn.Bhd in 1989, we have since grown from being a modest family concern to be one of the country’s leading names in the wooden pallets industry. <br /><br /> Today, we are more than just a manufacturer of wooden pallets, having diversified to become a one-stop holistic provider of services and products for Palletizing, Boxing, Crating, Packing & Recycling. Our clientele include many multinational corporations in the northern region of West Malaysia, as we have become known for our commitment and track record in providing top quality products and good value services in our field.',
    aboutBtn: 'Read More',
    // Homepage - Work Section
    worksTitle: 'OUR WORKS',
    worksStatement: 'A collection of cars we\'ve renovated with passion',
    worksImageTitle1: 'I\'m an image title',
    worksImageDescription1: 'Describe your image here. Use catchy text to tell people the story behind the photo. Go to “Manage Media” to add your content.',
    worksImageTitle2: 'I\'m an image title',
    worksImageDescription2: 'Describe your image here. Use catchy text to tell people the story behind the photo. Go to “Manage Media” to add your content.',
    worksImageTitle3: 'I\'m an image title',
    worksImageDescription3: 'Describe your image here. Use catchy text to tell people the story behind the photo. Go to “Manage Media” to add your content.',
    worksImageTitle4: 'I\'m an image title',
    worksImageDescription4: 'Describe your image here. Use catchy text to tell people the story behind the photo. Go to “Manage Media” to add your content.',
    worksImageTitle5: 'I\'m an image title',
    worksImageDescription5: 'Describe your image here. Use catchy text to tell people the story behind the photo. Go to “Manage Media” to add your content.',
    worksImageTitle6: 'I\'m an image title',
    worksImageDescription6: 'Describe your image here. Use catchy text to tell people the story behind the photo. Go to “Manage Media” to add your content.',
    worksImageTitle7: 'I\'m an image title',
    worksImageDescription7: 'Describe your image here. Use catchy text to tell people the story behind the photo. Go to “Manage Media” to add your content.',
    worksImageTitle8: 'I\'m an image title',
    worksImageDescription8: 'Describe your image here. Use catchy text to tell people the story behind the photo. Go to “Manage Media” to add your content.',
    // Homepage - Contact Section
    contactTitle: 'CONTACT US',
    contactQuote: 'Get a Quote',
    contactFormProduct: 'Product',
    contactFormEmail: 'Email',
    contactFormName: 'Name',
    contactFormSubject: 'Subject',
    contactFormMessage: 'Message',
    contactBtn: 'Drop a Message',
    contactQuoteBtn: 'Get Quote',
    contactValidate: 'This field is required.',
    // About Page
    visionTitle: 'OUR VISION',
    visionDescription: 'I\'m a paragraph. Click here to add your own text and edit me. It\'s easy. Just click "Edit Text" or double click me to add your own content and make changes to the font. I\'m a great place for you to tell a story and let your users know a little more about you.',
    missionTitle: 'OUR MISSION',
    missionDescription: 'I\'m a paragraph. Click here to add your own text and edit me. It\'s easy. Just click "Edit Text" or double click me to add your own content and make changes to the font. I\'m a great place for you to tell a story and let your users know a little more about you.',
    coreValueTitle: 'OUR CORE VALUES',
    coreValueDescription: 'I\'m a paragraph. Click here to add your own text and edit me. It\'s easy. Just click "Edit Text" or double click me to add your own content and make changes to the font. I\'m a great place for you to tell a story and let your users know a little more about you.',
    teamTitle: 'OUR TEAM',
    memberName1: 'Lim Tong Khuan',
    memberPosition1: 'Founder',
    memberName2: 'Yew Chee Fong',
    memberPosition2: 'Operation',
    memberName3: 'Lim Zheng Xun',
    memberPosition3: 'Project Manager',
    memberName4: 'Not Sure Yet',
    memberPosition4: 'Secretary',
    // Product Page
    productTitle1: 'Plywood Pallet',
    productDescription1: 'I\'m a paragraph. Click here to add your own text and edit me. It\'s easy. Just click "Edit Text" or double click me to add your own content and make changes to the font. I\'m a great place for you to tell a story and let your users know a little more about you.',
    productTitle2: 'Recycle Pallet',
    productDescription2: 'I\'m a paragraph. Click here to add your own text and edit me. It\'s easy. Just click "Edit Text" or double click me to add your own content and make changes to the font. I\'m a great place for you to tell a story and let your users know a little more about you.',
    productTitle3: 'Laminated Veneer Lumb Pallet',
    productDescription3: 'I\'m a paragraph. Click here to add your own text and edit me. It\'s easy. Just click "Edit Text" or double click me to add your own content and make changes to the font. I\'m a great place for you to tell a story and let your users know a little more about you.',
    productTitle4: 'Recycle Pallet',
    productDescription4: 'I\'m a paragraph. Click here to add your own text and edit me. It\'s easy. Just click "Edit Text" or double click me to add your own content and make changes to the font. I\'m a great place for you to tell a story and let your users know a little more about you.',
    productTitle5: 'Plastic Pallet',
    productDescription5: 'I\'m a paragraph. Click here to add your own text and edit me. It\'s easy. Just click "Edit Text" or double click me to add your own content and make changes to the font. I\'m a great place for you to tell a story and let your users know a little more about you.',
    productTitle6: 'Laminated Veneer Lumb Pallet',
    productDescription6: 'I\'m a paragraph. Click here to add your own text and edit me. It\'s easy. Just click "Edit Text" or double click me to add your own content and make changes to the font. I\'m a great place for you to tell a story and let your users know a little more about you.',
    // Service Page
    serviceTitle: 'OUR SERVICE',
    serviceTitle1: 'IN-HOME COLOR CONSULTANCY',
    serviceDescription1: 'I\'m a paragraph. Click to add your text and edit me. Let your users get to know you.',
    serviceTitle2: 'COATS & RESTORATION',
    serviceDescription2: 'I\'m a paragraph. Click to add your text and edit me. Let your users get to know you.',
    serviceTitle3: 'INDOOR & OUTDOOR PAINTING',
    serviceDescription3: 'I\'m a paragraph. Click to add your text and edit me. Let your users get to know you.',
    serviceTitle4: 'PALETTE PRODUCTION',
    serviceDescription4: 'I\'m a paragraph. Click to add your text and edit me. Let your users get to know you.',
    // Contact Page
    statement1: 'Do you have ',
    statement2: 'Ready for a ',
    statement3: 'We\'re here to ',
    keyword1: 'QUESTIONS?',
    keyword2: 'QUOTE?',
    keyword3: 'HELP!'
  },
  cn: {
    // HomePage - Landing
    welcomeTitle: '欢迎来到这里',
    welcomeMsg: '',
    welcomeBtn: '',
    // HomePage - Product Section
    productTitle: '',
    productAttributeOneTitle: '',
    productAttributeOneDescription: '',
    productAttributeTwoTitle: '',
    productAttributeTwoDescription: '',
    productAttributeThreeTitle: '',
    productAttributeThreeDescription: '',
    productAttributeFourTitle: '',
    productAttributeFourDescription: '',
    productBtn: '',
    // HomePage - About Section
    aboutTitle: '',
    aboutParagraph: '',
    aboutBtn: '',
    // HomePage - Work Section
    worksTitle: '',
    worksStatement: '',
    worksImageOneTitle: '',
    worksImageOneDescription: '',
    worksImageTwoTitle: '',
    worksImageTwoDescription: '',
    worksImageThreeTitle: '',
    worksImageThreeDescription: '',
    worksImageFourTitle: '',
    worksImageFourDescription: '',
    worksImageFiveTitle: '',
    worksImageFiveDescription: '',
    worksImageSixTitle: '',
    worksImageSixDescription: '',
    worksImageSevenTitle: '',
    worksImageSevenDescription: '',
    worksImageEightTitle: '',
    worksImageEightDescription: '',
    // HomePage - Contact Section
    contactTitle: '',
    contactQuote: 'Get a Quote',
    contactFormProduct: 'Product',
    contactFormEmail: '',
    contactFormName: '',
    contactFormSubject: '',
    contactFormMessage: '',
    contactBtn: '',
    contactQuoteBtn: 'Get Quote',
    contactValidate: 'This field is required.',
    // About Page
    visionTitle: '',
    visionDescription: '',
    missionTitle: '',
    missionDescription: '',
    coreValueTitle: '',
    coreValueDescription: '',
    teamTitle: '',
    memberName1: '',
    memberPosition1: '',
    memberName2: '',
    memberPosition2: '',
    memberName3: '',
    memberPosition3: '',
    memberName4: '',
    memberPosition4: '',
    // Product Page
    productTitle1: '',
    productDescription1: '',
    productTitle2: '',
    productDescription2: '',
    productTitle3: '',
    productDescription3: '',
    productTitle4: '',
    productDescription4: '',
    productTitle5: '',
    productDescription5: '',
    productTitle6: '',
    productDescription6: '',
    // Service Page
    serviceTitle1: '',
    serviceDescription1: '',
    serviceTitle2: '',
    serviceDescription2: '',
    serviceTitle3: '',
    serviceDescription3: '',
    serviceTitle4: '',
    serviceDescription4: '',
    // Contact Page
    statement1: '',
    statement2: '',
    statement3: '',
    keyword1: '',
    keyword2: '',
    keyword3: ''
  },
  bm: {
    // HomePage - Landing
    welcomeTitle: 'Welcome to Your Vue.js App',
    welcomeMsg: '',
    welcomeBtn: '',
    // HomePage - Product Section
    productTitle: '',
    productAttributeOneTitle: '',
    productAttributeOneDescription: '',
    productAttributeTwoTitle: '',
    productAttributeTwoDescription: '',
    productAttributeThreeTitle: '',
    productAttributeThreeDescription: '',
    productAttributeFourTitle: '',
    productAttributeFourDescription: '',
    productBtn: '',
    // HomePage - About Section
    aboutTitle: '',
    aboutParagraph: '',
    aboutBtn: '',
    // HomePage - Work Section
    worksTitle: '',
    worksStatement: '',
    worksImageOneTitle: '',
    worksImageOneDescription: '',
    worksImageTwoTitle: '',
    worksImageTwoDescription: '',
    worksImageThreeTitle: '',
    worksImageThreeDescription: '',
    worksImageFourTitle: '',
    worksImageFourDescription: '',
    worksImageFiveTitle: '',
    worksImageFiveDescription: '',
    worksImageSixTitle: '',
    worksImageSixDescription: '',
    worksImageSevenTitle: '',
    worksImageSevenDescription: '',
    worksImageEightTitle: '',
    worksImageEightDescription: '',
    // HomePage - Contact Section
    contactTitle: '',
    contactQuote: 'Get a Quote',
    contactFormProduct: 'Product',
    contactFormEmail: '',
    contactFormName: '',
    contactFormSubject: '',
    contactFormMessage: '',
    contactBtn: '',
    contactQuoteBtn: 'Get Quote',
    contactValidate: 'This field is required.',
    // About Page
    visionTitle: '',
    visionDescription: '',
    missionTitle: '',
    missionDescription: '',
    coreValueTitle: '',
    coreValueDescription: '',
    teamTitle: '',
    memberName1: '',
    memberPosition1: '',
    memberName2: '',
    memberPosition2: '',
    memberName3: '',
    memberPosition3: '',
    memberName4: '',
    memberPosition4: '',
    // Product Page
    productTitle1: '',
    productDescription1: '',
    productTitle2: '',
    productDescription2: '',
    productTitle3: '',
    productDescription3: '',
    productTitle4: '',
    productDescription4: '',
    productTitle5: '',
    productDescription5: '',
    productTitle6: '',
    productDescription6: '',
    // Service Page
    serviceTitle1: '',
    serviceDescription1: '',
    serviceTitle2: '',
    serviceDescription2: '',
    serviceTitle3: '',
    serviceDescription3: '',
    serviceTitle4: '',
    serviceDescription4: '',
    // Contact Page
    statement1: '',
    statement2: '',
    statement3: '',
    keyword1: '',
    keyword2: '',
    keyword3: ''
  }
}

export default new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'cn', // set fallback locale
  messages // set locale messages
})



// WEBPACK FOOTER //
// ./src/plugins/i18n.js